'use client';

import { Link } from '@/components/atoms/Link';
import styles from './index.module.scss';

interface BackToLinkProps {
  readonly backToSlug?: string;
  readonly translations: {
    readonly linkText: string;
  };
}

export function BackToLink({ backToSlug, translations: { linkText } }: BackToLinkProps): JSX.Element | null {
  if (!backToSlug) return null;
  return (
    <Link
      className={styles['back-link']}
      mode="light"
      type="S"
      href={`${backToSlug}`}
      direction="left"
      rel="nofollow"
    >
      {linkText}
    </Link>
  );
}
